import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OrganizationSiteTableComponent } from '../organization-site-table/organization-site-table.component';
import { OrganizationSiteFilterComponent } from '../organization-site-filter/organization-site-filter.component';
import { Subject } from 'rxjs';
import { OrganizationSiteFilterDto } from '../../interfaces/organization-site-filter-dto';
import { OrganizationSiteSearchComponent } from '../organization-site-search/organization-site-search.component';

@Component({
    selector: 'mmoga-sites',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        OrganizationSiteTableComponent,
        OrganizationSiteFilterComponent,
        OrganizationSiteSearchComponent
    ],
    templateUrl: './sites.component.html',
    styleUrl: './sites.component.scss'
})
export class SitesComponent {

    protected readonly searchFilter$ = new Subject<OrganizationSiteFilterDto>();
    protected readonly searchTerm$ = new Subject<string>();

    onFilter(filter: OrganizationSiteFilterDto): void {
        this.searchFilter$.next(filter);
    }

    onSearch(term: string): void {
        this.searchTerm$.next(term);
    }
}
